import React from 'react';
import { ArrowRight } from 'lucide-react';
interface FlowStepsProps {
  steps: string[];
  tone?: 'light' | 'dark';
  align?: 'start' | 'center';
  size?: 'sm' | 'lg';
  label?: string;
}
export function FlowSteps({
  steps,
  tone = 'light',
  align = 'center',
  size = 'sm',
  label
}: FlowStepsProps) {
  const chipTone = tone === 'dark' ? 'bg-white/5 text-white border-white/15' : 'bg-zinc-800 text-white border-zinc-700';
  const chipSize = size === 'lg' ? 'px-5 py-2.5 text-base md:text-lg' : 'px-3 py-1.5 text-xs md:text-sm';
  return <ol aria-label={label ?? steps.join(' to ')} className={`flex flex-wrap items-center gap-x-2 gap-y-2 ${align === 'center' ? 'justify-center' : 'justify-start'}`} data-id="element-113" data-mp="34oefupwqwx4w">
      {steps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-114" data-mp="3ilky8jdk4ttl" data-mpi={index}>
          <span className={`font-display font-extrabold uppercase tracking-wide rounded-lg border whitespace-nowrap ${chipTone} ${chipSize}`} data-id="element-115" data-mp="3ik0773qgbt0h">
            {step}
          </span>
          {index < steps.length - 1 && <ArrowRight size={size === 'lg' ? 20 : 16} className="shrink-0 text-amber-400" aria-hidden="true" data-id="element-116" data-mp="2j49rrbjzdoc" />}
        </li>)}
    </ol>;
}